"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var React = require("react");
var SvgSuccess = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 49" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.93 12.481a1.5 1.5 0 0 1 .247 2.107L21.498 34.425a3.645 3.645 0 0 1-.847.795l-.006.005a3.599 3.599 0 0 1-4.98-.972l-4.891-6.941a1.5 1.5 0 0 1 2.452-1.728l4.9 6.954.02.03a.599.599 0 0 0 .974.028l.017-.022 15.686-19.846a1.5 1.5 0 0 1 2.107-.247z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24 3C12.402 3 3 12.402 3 24s9.402 21 21 21 21-9.402 21-21S35.598 3 24 3zM0 24C0 10.746 10.746 0 24 0s24 10.746 24 24-10.746 24-24 24S0 37.254 0 24z" }))); };
exports["default"] = SvgSuccess;
